import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { PackagesPriceBreakdown } from "./component";
import { IStoreState } from "../../../../reducers/types";

const mapStateToProps = (_: IStoreState) => {
  return {};
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PackagesPriceBreakdownConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedPackagesPriceBreakdown = withRouter(
  connector(PackagesPriceBreakdown)
);
